import React, { useEffect, useState } from "react";
import { useMemo } from "react";
import { useCallback } from "react";

import "./ActivityView.css";

//Components
import ActivityCard from "./ActivityCard";
import Button from "../Other Components/button";
import PageLoader from "../Other Components/pageLoader";
import Title from "../Other Components/Title";
import SearchBar from "Components/Other Components/searchBar";

//Functions and hooks
import { GetActivity } from "../../BackendAccess/DataHooks";
import { useErrorHandler } from "../../hooks/errorHandler";
import { useNotification } from "../../Contexts/NotificationContext";
import { useTranslation } from "react-i18next";

export default function ActivityView() {
  const [activity, setActivity] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pageError, setPageError] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");

  const { showNotification } = useNotification();
  useErrorHandler(error, showNotification, setPageError);

  const [lastID, setLastID] = useState(0);

  const itemsToFetch = 10;

  let itemCounter = 0;

  const [btnDisabled, setBtnDisabled] = useState(false);

  const { t } = useTranslation();

  const fetchActivity = async () => {
    try {
      setLoading(true);
      const [data, error] = await GetActivity(lastID, itemsToFetch);
      if (error) {
        setError(error);
      } else {
        const newActivity = [...activity, ...data];
        setActivity(newActivity);
        if (data.length < itemsToFetch) {
          setBtnDisabled(true);
        }
        itemCounter = newActivity.length;
        setLastID(itemCounter);
      }
      console.log("Activity data", data, error);
    } catch (err) {
      setError(err);
      console.log("Activity error", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActivity();
  }, []);

  const handleSearchChange = useCallback((term) => {
    setSearchTerm(term);
  }, []);

  const searchFilteredItems = useMemo(() => {
    if (!searchTerm) return activity;

    const lowerCaseTerm = searchTerm.toLowerCase();
    return activity.filter(
      (item) =>
        item.Username.toLowerCase().includes(lowerCaseTerm) ||
        item.Action.toString().toLowerCase().includes(lowerCaseTerm) ||
        (item.ObjectType?.toString() || "")
          .toLowerCase()
          .includes(lowerCaseTerm) ||
        item.Detail.toString().toLowerCase().includes(lowerCaseTerm)
    );
  }, [searchTerm, activity]);

  const createCards = () => {
    return searchFilteredItems.map((item, index) => (
      <ActivityCard
        key={index}
        first={index === 0}
        last={index === searchFilteredItems.length - 1}
        activity={item}
      />
    ));
  };
  return (
    <div className="activity-view-container">
      <PageLoader loading={loading} error={pageError}>
        <Title>{t("Activity")}</Title>
        <div className="search-bar-container">
          <SearchBar
            searchTerm={searchTerm}
            onSearchChange={handleSearchChange}
            placeholder={t("Search activity...")}
          />
        </div>
        <div className="activity-view-content">
          <div className="activity-card-container">{createCards()}</div>
          <Button
            onClick={() => {
              fetchActivity();
            }}
            disabled={btnDisabled}
            tutorialId="activity-show-more-btn"
          >
            {t("Show more")}
          </Button>
        </div>
      </PageLoader>
    </div>
  );
}
